<template>
  <v-text-field readonly v-model="lazyValue" @click:append="onRefClick" append-icon="mdi-magnify" :dense="dense" :hide-details="hideDetails" :disabled="disabled" :label="label" :outlined="outlined" :clearable="!required" @click:clear="onClear">
    <template v-slot:prepend-inner>
      <v-dialog v-model="refModelVisible" v-if="refModelVisible" persistent scrollable max-width="580">
        <v-card :loading="loading" min-height="420">
          <v-card-title>
            {{title}}
            <a class="ml-2 mt-1 caption text-decoration-none" @click="init">刷新</a>
            <!-- <a target="_blank" class="ml-2 mt-1 caption text-decoration-none" href="/profile/file">上传文件</a> -->
          </v-card-title>
          <v-card-text>
            <v-treeview open-on-click item-key="path" :active.sync="selectedRows" return-object :items="dataList" dense activatable :load-children="listFile">
              <template v-slot:label="{item}">
                <span class="teal--text">{{item.name}}</span>
                <code class="ml-1">{{Utility.kindFileSize(item.size) }}</code>
              </template>
              <template v-slot:prepend="{ item,open }">
                <v-icon color="teal" v-if="item.dir">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                <v-icon color="teal" v-else>{{getFileIcon(item)}}</v-icon>
              </template>
            </v-treeview>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="onRefCancel">取消</v-btn>
            <v-btn color="primary" @click="onRefOk" :disabled="!selectedRows.length">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-text-field>
</template>
<script>
/* eslint-disable no-console */
import EditorProps from '../EditorProps';

export default {
  name: 'path-ref-editor',
  props: {
    ...EditorProps.custom, ...EditorProps.vuetify,
    title: { type: String, default: '文件选择' },
    onlyName: { type: Boolean, default: false }
  },
  data () {
    return {
      api: { getChildren: '/api/file/getChildren' },
      lazyValue: '',
      refModelVisible: false,
      loading: false,
      dataList: [],
      selectedRows: []
    }
  },
  watch: {
    value (v) {
      this.setLazyValue(v);
    },
    refModelVisible (v) {
      if (v) this.init();
    }
  },
  created () {
    this.setLazyValue(this.value);
  },
  methods: {
    init () {
      this.selectedRows = [];
      this.dataList = [];
      this.listFile();
    },
    onClear () { // 清除事件
      this.$emit('input', '');
    },
    onRefClick () {
      this.refModelVisible = true;
    },
    onRefCancel () { // 参照页面: 取消点击事件
      this.refModelVisible = false;
    },
    onRefOk () { // 参照页面: 确定点击事件
      this.$emit('input', this.selectedRows[0].path);
      this.refModelVisible = false;
    },
    listFile (item) {
      if (!item) {
        this.requester({}).then(res => {
          let d = res.data || [];
          d.forEach(item => { if (item.dir) item.children = [] });
          this.dataList = d;
        })
      } else {
        return this.requester({ data: item.path }).then(res => {
          let d = res.data || [];
          d.forEach(item => { if (item.dir) item.children = [] });
          item.children = d;
        })
      }
    },
    getFileIcon (item) {
      let name = item.name;
      let parts = name.split('.');
      let type = parts[parts.length - 1].toLowerCase();
      return this.Utility.FILE_ICON[type] || this.Utility.FILE_ICON.none;
    },
    requester (param) {
      return this.$post(this.api.getChildren, param);
    },
    setLazyValue (path) {
      if (!path) this.lazyValue = '';
      else {
        let arr = path.split('/');
        this.lazyValue = this.onlyName ? arr[arr.length - 1] : path;
      }
    }
  }
}
</script>